import getHumanNumberWithSymbol from './getHumanNumberWithSymbol';

function getHumanNumberFormat(data = 0, toFixed = 1, toFixedIfLess1000) {
	const result = getHumanNumberWithSymbol(data, toFixed, toFixedIfLess1000);
	return `${result[0]}${result[1] ? `${result[1]}` : ''}`;
}

export default getHumanNumberFormat;
